import useSWR from 'swr';
import { PharmacyType } from '../types/pharmacyType';

export type Pharmacy = {
  id: number;
  name: string;
  api_integration: boolean;
  integration_type: PharmacyType;
};
export function usePharmacies() {
  const { data, error, mutate, isLoading } = useSWR<any>(`medical/pharmacies/`);
  return { data: data?.results as Array<Pharmacy>, error, mutate, arePharmaciesLoading: isLoading };
}
